import { TableProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Table, Tag, Typography } from '@thinknet-gmbh/platform-common-ui';
import { ProjectStatusesEnum } from '@thinknet-gmbh/platform-common';

import { dateFormat } from 'src/common/helpers/date.helpers';
import { ROUTES } from 'src/components/app/app-routes.constants';
import { PROJECT_TYPE_COLORS } from 'src/pages/projects/projects.constants';

const CustomerRelatedProjects = ({ ...props }: TableProps<any>) => {
  const navigate = useNavigate();
  const { t } = useTranslation(['common', 'projects']);

  return (
    <Table
      {...props}
      t={t}
      rowKey={record => record._id}
      onRow={record => ({
        onClick: () => navigate(`${ROUTES.project}/${record._id}`),
      })}
    >
      <Table.Column
        title={t('projects:labels.projectName')}
        key="name"
        dataIndex="name"
        render={name => <Typography>{name}</Typography>}
      />
      <Table.Column
        title={t('projects:labels.projectNumber')}
        key="projectNumber"
        dataIndex="projectNumber"
        render={projectNumber => <Typography>{`№ ${projectNumber}`}</Typography>}
      />
      <Table.Column
        title={t('projects:labels.startDate')}
        dataIndex="startDate"
        key="startDate"
        sorter
        render={startDate => <Typography>{startDate ? dateFormat(startDate) : '-'}</Typography>}
      />
      <Table.Column
        title={t('projects:labels.plannedHours')}
        dataIndex="plannedHours"
        key="plannedHours"
        render={plannedHours => <Typography>{plannedHours}</Typography>}
      />
      <Table.Column
        title={t('projects:labels.projectType')}
        dataIndex="status"
        key="status"
        render={status => {
          const { background, fontColor } = PROJECT_TYPE_COLORS[status as ProjectStatusesEnum];

          return (
            <Tag background={background} fontColor={fontColor}>
              {String(status).toLowerCase()}
            </Tag>
          );
        }}
      />
    </Table>
  );
};

export default CustomerRelatedProjects;
